import { trackEvent } from './pixel'

export type Plan = 'pro' | 'elite'

export const CHECKOUT_URLS: Record<Plan, string> = {
  pro: 'https://profelisto.com.ar/checkouts/cn/hWNDA9banw0gpfAYIoldTPd4/es-ar?_r=AQABXVi-EDprYt5yQIJeA9OCthN1wF_31BV2Jpl9l9Y01-Q',
  elite:
    'https://profelisto.com.ar/checkouts/cn/hWNDA9bs9oqB2q4uvL4klInq/es-ar?_r=AQABsErwrqZKQKDmBrksx_ortCiMlyKyeOdr08EG3FcgjXw',
}

export function goToCheckout(plan: Plan) {
  trackEvent('InitiateCheckout', {
    content_name: plan === 'elite' ? 'Megapack Élite' : 'Pack Profesional',
    value: plan === 'elite' ? 27990 : 18990,
    currency: 'ARS',
  })
  window.location.href = CHECKOUT_URLS[plan]
}
